import { useState } from "react"
import { useHistory } from "react-router-dom"
import { auth } from '../firebase/config'
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth'

export  const useSignUp = () =>{

  const [error, setError] = useState(null)
  const history = useHistory()

  const signup = (name,email, password) =>{
    setError(null)

    createUserWithEmailAndPassword(auth, email, password)
      .then((res)=>{
        updateProfile(auth.currentUser, {
          displayName:name
        })
        .then(
        history.push('/')
        )
      })
      .catch(()=>{
        setError("Network Error or Incorrect Credentials : Password must be least six characters long")
      })
  }

  return { signup, error }


}